// poem：作品頁的「詩」區塊（2026-10-04《彼岸花》〈夢的彼岸〉；哲宇：「我想要把我的詩完整放，但又不想要讓版面太長」）。
// 整首照原文分段放，不收合、不給「展開全文」；靠排法省高度：桌機用 CSS 多欄（段落不拆欄），手機單欄。
// 純函式、沒有 Vue 依賴：pageWorkDetail.vue 與 scripts/test-work-detail-contract.cjs 共用同一套規則。
//
// 資料（work-details.json blocks 的一筆）：
//   { type:'poem', id, title:{zh,en}, cite:{zh,en}, note?:{zh,en},
//     stanzas:{ zh:[[行,…],…], en?:[[行,…],…] },        // 一段一個陣列，一行一個字串，標點與空白照原文
//     original?:'zh',                                      // 英文頁先放中文原文，再放 en（作者自己的英譯）
//     labels?:{ original:{zh,en}, translation:{zh,en} } }  // 兩個版本並列時各自的小標
// 規則：中文頁只放 zh（沒有 zh 才退回 en）；英文頁 original:'zh' 時放原文＋英譯，沒有英譯就只放原文（說明寫在 note）。

const clean = stanzas => (Array.isArray(stanzas) ? stanzas : [])
  .map(s => (Array.isArray(s) ? s : []).map(l => String(l ?? '')).filter(l => l.trim()))
  .filter(s => s.length)

const pickText = (value, zh) => (value == null ? '' : typeof value === 'string' ? value : value[zh ? 'zh' : 'en'] || value.en || value.zh || '')

// 欄數：行數決定上限（≤6 行一欄、≤12 行兩欄、其餘三欄），最長那一行決定能不能排窄（中日文一字算兩個單位），
// 也不會多過段數（段落不拆欄，三段的詩排四欄只會空一欄）
export function poemColumns(stanzas) {
  const lines = stanzas.reduce((n, s) => n + s.length, 0)
  const width = l => [...l].reduce((w, ch) => w + (/[⺀-鿿豈-﫿＀-￯]/.test(ch) ? 2 : 1), 0)
  const longest = Math.max(0, ...stanzas.flat().map(width))
  const byLines = lines <= 6 ? 1 : lines <= 12 ? 2 : 3
  const byWidth = longest > 44 ? 1 : longest > 30 ? 2 : 3
  return Math.max(1, Math.min(byLines, byWidth, stanzas.length))
}

export function poemVersions(block, zh) {
  const S = block?.stanzas || {}
  const zhS = clean(S.zh), enS = clean(S.en)
  const out = []
  if (zh) {
    if (zhS.length) out.push({ lang: 'zh-Hant', stanzas: zhS })
    else if (enS.length) out.push({ lang: 'en', stanzas: enS })
  } else {
    const both = block?.original === 'zh' && zhS.length && enS.length
    if (block?.original === 'zh' && zhS.length) out.push({ lang: 'zh-Hant', stanzas: zhS, label: both ? pickText(block.labels?.original, false) || 'Original' : '' })
    if (enS.length) out.push({ lang: 'en', stanzas: enS, label: both ? pickText(block.labels?.translation, false) || 'English' : '' })
    if (!out.length && zhS.length) out.push({ lang: 'zh-Hant', stanzas: zhS })
  }
  return out.map(v => ({ ...v, cols: poemColumns(v.stanzas) }))
}
